<template>
    <div :class="elementClasses" :style="componentStyle" @click="onComponentClick"
         @mouseover="isMouseOver = true" @mouseout="isMouseOver = false">

        <label-renderer v-if="component.type === 'Label'" :component="component" :layout="layout"></label-renderer>
        <text-renderer v-if="component.type === 'Text'" :component="component" :layout="layout"></text-renderer>
        <header-renderer v-if="component.type === 'Header'" :component="component" :layout="layout"></header-renderer>
        <link-renderer v-else-if="component.type === 'Link'" :component="component" :layout="layout"></link-renderer>
        <icon-renderer v-if="component.type === 'Icon'" :component="component" :layout="layout"></icon-renderer>
        <image-renderer v-if="component.type === 'Image'" :component="component"></image-renderer>
        <video-renderer v-if="component.type === 'Video'" :component="component"
                        :video-url="component.value.url" :embed-html="component.value.embedHtml"></video-renderer>
        <view-name-display v-if="component.type === 'View'" :view-id="component.value"></view-name-display>
        <button-renderer v-if="component.type === 'Button'" :component="component" :layout="layout"></button-renderer>

        <row-component-renderer v-if="component.type === 'RowContainer'" :component="component"
                                :layout="layout"></row-component-renderer>

        <!-- Experimenting with an Embedded Row -->
        <row-container v-if="component.type === 'InternalRow'" :row="component"
                       class="w-100" :index="-1" key="InternalRow" :layout="layout"></row-container>

        <!-- dropdown editor -->
        <component-edit-dropdown :component="component" :column="column" :layout="layout"
                                 @containerWrapClick="onContainerWrapClick"
                                 @editText="$emit('editText')"
                                 @iconClick="$emit('iconClick')"
                                 @imageClick="$emit('imageClick')"></component-edit-dropdown>
    </div>
</template>

<script>

    import IconRenderer from "../../views/renderers/IconRenderer.vue";
    import LinkRenderer from "../../views/renderers/LinkRenderer.vue";
    import LabelRenderer from "../../views/renderers/LabelRenderer.vue";
    import HeaderRenderer from "../../views/renderers/HeaderRenderer.vue";
    import ImageRenderer from "../../views/renderers/ImageRenderer.vue";
    import ButtonRenderer from '../../views/renderers/ButtonRenderer.vue'
    import ViewNameDisplay from "../view/ViewNameDisplay.vue";
    import ComponentEditDropdown from "../view/ComponentEditDropdown.vue";
    import RowComponentRenderer from "../../views/renderers/RowComponentRenderer.vue";
    import ComponentUtil from "../../utils/ComponentUtil";
    import VideoRenderer from "../../views/renderers/VideoRenderer.vue";
    import TextRenderer from "../../views/renderers/TextRenderer.vue";

    export default {
        name: 'ElementContainer',
        components: {
            TextRenderer, VideoRenderer, RowComponentRenderer, ComponentEditDropdown,
            ViewNameDisplay, ImageRenderer, HeaderRenderer, LabelRenderer, LinkRenderer, IconRenderer, ButtonRenderer},
        props: ['column', 'component', 'layout', 'defaultClasses'],
        computed: {
            elementClasses() {
                if(this.defaultClasses) {
                    return this.defaultClasses + ' ' + this.widthClass + ' ' + this.marginClass + ' ' + this.paddingClass + ' ' + this.borderClasses
                }
                return this.marginClass + ' ' + this.paddingClass + ' ' + this.borderClasses + ' ' + this.widthClass
            },
            widthClass() {
                if(this.component.type === 'InternalRow') {
                    return 'w-100'
                }

                return ''
            },
            marginClass() {
                if(!this.component.margin) {
                    return ''
                }

                return webase.utils.ui.getMarginClass(this.component.margin)
            },
            paddingClass() {
                if(!this.component.padding) {
                    return ''
                }

                return webase.utils.ui.getPaddingClass(this.component.padding)
            },
            borderClasses() {
                let borderCssClasses = ''

                if(this.hasBorder) {
                    borderCssClasses = " border "
                }

                if(this.hasBorder && !this.isCustomBorderColor) {
                    borderCssClasses += (" border-" + this.component.border.color)
                }

                return borderCssClasses
            },

            hasBorder() {
                return this.component.border && this.component.border.type && this.component.border.type !== 'none'
            },

            isCustomBorderColor() {
                return this.component.border && this.component.border.color && this.component.border.color.indexOf('#') === 0
            },

            componentStyle() {
                return {
                    ...this.colorBorderStyle,
                    ...this.borderRadiusStyle,
                    ...this.borderWidthStyle
                }
            },

            colorBorderStyle() {
                return this.isCustomBorderColor ? { borderColor: this.component.border.color + '  !important'} : {}
            },

            borderRadiusStyle() {
                return this.hasBorderRadius ? { borderRadius: this.component.border.cornerRadius + 'px' } : {}
            },

            borderWidthStyle() {
                return this.hasBorderWidth ? { borderWidth: this.component.border.width + 'px !important' } : {}
            },

            hasBorderRadius() {
                return this.component.border && this.component.border.type !== 'none' && this.component.border.cornerRadius
            },

            hasBorderWidth() {
                return this.component.border && this.component.border.type !== 'none' && this.component.border.width
            }

        },
        data() {
            return {
                model: webase.model,
                isMouseOver: false
            }
        },
        mounted() {
            if(this.component.type === 'InternalRow') {
                this.component.parentColumn = this.column
            }

            if(!this.component.margin) {
                this.component.margin = {
                    side: 'none',
                    value: '0'
                }
            }

            if (!this.component.padding) {
                this.component.padding = {
                    side: 'none',
                    value: '0'
                }
            }
        },
        methods: {
            onComponentClick() {
                console.log('onComponentClick')
                if(this.component.type === 'RowContainer') {
                    return
                }

                // console.log('ElementContainer.onComponentClick')
                webase.utils.layout.deselectComponents(this.layout)
                this.component.selected = true
                this.layout.selectedComponent = this.component

                webase.utils.layout.deselectColumns(this.layout)
                this.column.selected = true
                this.layout.selectedColumn = this.column
            },

            onContainerWrapClick() {
                //$('#componentContextMenu').dropdown('dispose')
                let componentUtil = new ComponentUtil()
                componentUtil.wrapInContainer(this.column, this.component)
                this.$emit('columnRefresh')
            }
        }
    }
</script>
